import { render, staticRenderFns } from "./follow-up-record.vue?vue&type=template&id=7b084aac&scoped=true"
import script from "./follow-up-record.vue?vue&type=script&lang=js"
export * from "./follow-up-record.vue?vue&type=script&lang=js"
import style0 from "./follow-up-record.vue?vue&type=style&index=0&id=7b084aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b084aac",
  null
  
)

export default component.exports